import { useIntl } from "react-intl";

export const PromotionItem = ({ onClick, promo, className = "" }) => {
  const intl = useIntl();

  return (
    <div
      className={`rounded p-3 border ${className}`}
      style={onClick ? { cursor: "pointer" } : undefined}
      onClick={onClick}
    >
      <div className="fw-bold pb-2 mb-2 border-bottom">
        {promo.promotiontitle}
      </div>
      <div className="d-flex">
        <div className="pe-2">
          {intl.formatMessage({ id: "amountRange" })} :{" "}
        </div>
        <div>{promo.minmaxrequest}</div>
      </div>
      <div className="d-flex">
        <div className="pe-2">{intl.formatMessage({ id: "rollOver" })} : </div>
        <div>{promo.turnover}</div>
      </div>
      <div className="d-flex">
        <div className="pe-2">{intl.formatMessage({ id: "gameType" })} :</div>
        <div>
          {promo.promotionGameTypeLists
            ?.map((promoGameType) => promoGameType.gametype)
            .join(",")}
        </div>
      </div>
    </div>
  );
};
